import { Mail, MapPin, Phone } from 'lucide-react';
import { useSiteConfig } from '@/contexts/SiteConfigContext';

export function Contact() {
  const { config: siteConfig } = useSiteConfig();
  const eldoret = {
    email: siteConfig?.connectEmail?.trim() || '',
    phone: siteConfig?.connectPhone?.trim() || '',
    address: siteConfig?.connectAddress?.trim() || '',
  };
  const nairobi = {
    email: siteConfig?.connectEmailNairobi?.trim() || '',
    phone: siteConfig?.connectPhoneNairobi?.trim() || '',
    address: siteConfig?.connectAddressNairobi?.trim() || '',
  };

  return (
    <div className="relative overflow-hidden">
      <section className="py-20 md:py-28 px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-display font-bold text-foreground mb-6">Contact</h1>
          <p className="text-lg text-muted-foreground mb-12 max-w-2xl">
            Get in touch with the Homeland team. We&apos;d love to hear from you.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            <div className="rounded-2xl border border-border bg-card p-6 md:p-8 shadow-sm">
              <p className="text-xs font-semibold uppercase tracking-wide text-accent mb-4">Eldoret</p>
              <div className="space-y-4">
                {eldoret.email ? (
                  <div className="flex items-start gap-3 text-foreground">
                    <Mail className="w-5 h-5 text-accent shrink-0 mt-0.5" />
                    <a href={`mailto:${eldoret.email}`} className="hover:text-accent transition-colors break-all">
                      {eldoret.email}
                    </a>
                  </div>
                ) : null}
                {eldoret.phone ? (
                  <div className="flex items-start gap-3 text-foreground">
                    <Phone className="w-5 h-5 text-accent shrink-0 mt-0.5" />
                    <a href={`tel:${eldoret.phone.replace(/\s/g, '')}`} className="hover:text-accent transition-colors">
                      {eldoret.phone}
                    </a>
                  </div>
                ) : null}
                {eldoret.address ? (
                  <div className="flex items-start gap-3 text-foreground">
                    <MapPin className="w-5 h-5 text-accent shrink-0 mt-0.5" />
                    <span className="text-muted-foreground">{eldoret.address}</span>
                  </div>
                ) : null}
                {!eldoret.email && !eldoret.phone && !eldoret.address && (
                  <p className="text-sm text-muted-foreground">Eldoret contact details can be added in the admin public site settings.</p>
                )}
              </div>
            </div>
            <div className="rounded-2xl border border-border bg-card p-6 md:p-8 shadow-sm">
              <p className="text-xs font-semibold uppercase tracking-wide text-accent mb-4">Nairobi</p>
              <div className="space-y-4">
                {nairobi.email ? (
                  <div className="flex items-start gap-3 text-foreground">
                    <Mail className="w-5 h-5 text-accent shrink-0 mt-0.5" />
                    <a href={`mailto:${nairobi.email}`} className="hover:text-accent transition-colors break-all">
                      {nairobi.email}
                    </a>
                  </div>
                ) : null}
                {nairobi.phone ? (
                  <div className="flex items-start gap-3 text-foreground">
                    <Phone className="w-5 h-5 text-accent shrink-0 mt-0.5" />
                    <a href={`tel:${nairobi.phone.replace(/\s/g, '')}`} className="hover:text-accent transition-colors">
                      {nairobi.phone}
                    </a>
                  </div>
                ) : null}
                {nairobi.address ? (
                  <div className="flex items-start gap-3 text-foreground">
                    <MapPin className="w-5 h-5 text-accent shrink-0 mt-0.5" />
                    <span className="text-muted-foreground">{nairobi.address}</span>
                  </div>
                ) : null}
                {!nairobi.email && !nairobi.phone && !nairobi.address && (
                  <p className="text-sm text-muted-foreground">Nairobi contact details can be added in the admin public site settings.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
